import { Controller } from "@hotwired/stimulus"

// Content is visible by default; motion only enhances elements below the fold.
export default class extends Controller {
  connect() {
    this.preference = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.reset = () => this.setup()
    this.preference.addEventListener("change", this.reset)
    this.setup()
  }

  setup() {
    this.revealAll()
    if (this.preference.matches || !("IntersectionObserver" in window)) return

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        entry.target.classList.remove("relay-reveal-pending")
        this.observer.unobserve(entry.target)
      })
    }, { threshold: 0.08 })

    this.element.querySelectorAll(".relay-step, .relay-data-copy, .relay-whatsapp-copy, .relay-whatsapp-preview, .relay-close > *").forEach(element => {
      if (element.getBoundingClientRect().top < window.innerHeight) return
      element.classList.add("relay-reveal-pending")
      this.observer.observe(element)
    })
  }

  revealAll() {
    this.observer?.disconnect()
    this.element.querySelectorAll(".relay-reveal-pending").forEach(element => {
      element.classList.remove("relay-reveal-pending")
    })
  }

  disconnect() {
    this.revealAll()
    this.preference.removeEventListener("change", this.reset)
  }
}
